import React from 'react';
import './pullQuote.scss';
import pullQuotesData from './pullQuoteData.js';

const PullQuoteWImg = ({ index }) => {
  const pq = pullQuotesData[index];
  return (
    <div className="pullQuoteWImg">
      <div className="pullQuoteWImg__photo">
        <img src={pq.image} alt="man" />
      </div>
      <div className="pullQuoteWImg__text">
        <p>{pq.quote}</p>
        <p>{pq.author}</p>
      </div>
    </div>
  );
};

export default PullQuoteWImg;
